import { SET_USER_DATA, CLEAR_USER_DATA } from '../actions';

export const setUserData = payload => ({
    type: SET_USER_DATA,
    payload
})
export const clearUserData = () => ({
    type: CLEAR_USER_DATA
})